import { cn } from "@/lib/utils";
import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-[#f44336] text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground",
        ghost: "text-foreground text-primary px-3 py-1 border-primary border-2",
        anonymous:
          "border-transparent bg-[#502D7B] text-destructive-foreground hover:bg-destructive/80",
        success:
          "border-transparent bg-[#22c55e] text-destructive-foreground hover:bg-destructive/80",
        pending:
          "border-transparent bg-[#eab308] text-destructive-foreground hover:bg-destructive/80",
        plans:
          "border-transparent bg-[#38BDF8] text-destructive-foreground hover:bg-destructive/80",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

const Badge = React.forwardRef<HTMLDivElement, BadgeProps>(
  ({ className, variant, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(badgeVariants({ variant }), className)}
        {...props}
      />
    );
  }
);

Badge.displayName = "Badge";

export { Badge, badgeVariants };
